///jacques-andre-editeur\proshop-v2\frontend\src\components\ALaUne.jsx
import { Link } from 'react-router-dom';
import { Carousel, Image, Container } from 'react-bootstrap';
import Message from './Message';
import { useGetAlauneQuery } from '../slices/alauneApiSlice';
import DOMPurify from 'dompurify';


const ALaUne = ({ nouveautes }) => {

  const { data: alaune, isLoading, error } = useGetAlauneQuery();
  const isMobile = window.innerWidth <= 991.98;

  // === RENDER SPECIFIQUE DES LIVRES ===

  const renderBook = (highliteBook, etiquette) => {
    if (!highliteBook.bookId) return null;

    const isCollectif = highliteBook.bookId.author1?.lastName === 'Collectif';
    const author2Exists = !!highliteBook.bookId.author2;
    const sliceLength = isMobile ? 150 : 250;
    

    return (
      <Carousel.Item key={highliteBook._id}>
        <Link to={`/livre/${highliteBook.bookId.slug}`}>
          <div className="aLaUneTop">
            <Container className="ventre">
              <div className="content">
                <span className="badge-highlite">{etiquette}</span>
                <Image src={highliteBook.bookId.cover} alt={highliteBook.bookId.title} fluid className="imageALaUne" />
                <p className="auteurs">
                  <span>{highliteBook.bookId.author1.firstName} {highliteBook.bookId.author1.lastName}
                  {author2Exists && (
                    <>, {highliteBook.bookId.author2.firstName} {highliteBook.bookId.author2.lastName}</>
                  )}
                  </span>
                </p>
                <h2>{highliteBook.bookId.title}</h2>
                <div className="description">
                  <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(highliteBook.bookId.description
                    .replace(/<\/?p>/g, ' ')        // supprime les balises <p> et </p>
                    .replace(/<br\s*\/?>/g, ' ')   // remplace <br> ou <br/> par un espace
                    .replace(/(\r\n|\n|\r)/gm, ' ') // remplace les \n restants
                    .slice(0, sliceLength) + '...') }} />
                  <b>{highliteBook.bookId.price} €</b>
                </div>
                <p className="ensavoirplus"><b>En savoir plus</b></p>
              </div>
            </Container>
          </div>
          <Container className="slogan"><span className="catchphrase">{highliteBook.bookId.catchphrase}</span></Container>
        </Link>
      </Carousel.Item>

    );
  };

  // === RENDER SPECIFIQUE DES NEWS ===

  const renderNews = (highliteNews, etiquette) => {
    if (!highliteNews.newsId) return null;
    const sliceLength = isMobile ? 150 : 250;
    
    return (
      <Carousel.Item key={highliteNews._id}>
        <Link to={`/actualites`}>
          <div className="aLaUneTop">
            <Container className="ventre">
              <div className="content">
                <span className="badge-highlite">{etiquette}</span>
                <Image src={highliteNews.newsId.image} alt={highliteNews.newsId.title} fluid className="imageALaUne" />

                <h2>{highliteNews.newsId.title}</h2>

                {!(isMobile && highliteNews.newsId.title.length > 40) && 
                (
                <div className="description">
                  <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(highliteNews.newsId.description
                    .replace(/<\/?p>/g, ' ')        // supprime les balises <p> et </p>
                    .replace(/<br\s*\/?>/g, ' ')   // remplace <br> ou <br/> par un espace
                    .replace(/(\r\n|\n|\r)/gm, ' ') // remplace les \n restants
                    .slice(0, sliceLength) + '...') }} />
                </div>
                )}
                <p className="ensavoirplus"><b>En savoir plus</b></p>
              </div>
            </Container>
          </div>
        </Link>
      </Carousel.Item>

    );
  };

  // === RENDER SPECIFIQUE DES Auteurs ===

  const renderAuthor = (highliteAuthor, etiquette) => {
    if (!highliteAuthor.authorId) return null;
    const sliceLength = isMobile ? 200 : 450;

    return (
      <Carousel.Item key={highliteAuthor._id}>
        <Link to={`/auteur/${highliteAuthor.authorId.slug}`}>
          <div className="aLaUneTop">
            <Container className="ventre">
              <div className="content">
                <span className="badge-highlite">{etiquette}</span>
                <Image src={highliteAuthor.authorId.photo} alt={highliteAuthor.authorId.firstName + ' ' + highliteAuthor.authorId.lastName} fluid className="imageALaUne" />
                <p className="auteurs"> 
                </p>
                <h2>{highliteAuthor.authorId.firstName + ' ' + highliteAuthor.authorId.lastName}</h2>

                <div className="description">
                  <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(highliteAuthor.authorId.bio
                    .replace(/<\/?p>/g, ' ')        // supprime les balises <p> et </p>
                    .replace(/<br\s*\/?>/g, ' ')   // remplace <br> ou <br/> par un espace
                    .replace(/(\r\n|\n|\r)/gm, ' ') // remplace les \n restants
                    .slice(0, sliceLength) + '...') }} />
                </div>
                <p className="ensavoirplus"><b>En savoir plus</b></p>
              </div>
            </Container>
          </div>
        </Link>
      </Carousel.Item>

    );
  };

  // === RENDER SPECIFIQUE DES Collections ===

  const renderBooksCollection = (highliteBooksCollection, etiquette) => {
    if (!highliteBooksCollection.booksCollectionId) return null;
    const sliceLength = isMobile ? 250 : 450;
    return (
      <Carousel.Item key={highliteBooksCollection._id}>
        <Link to={`/auteur/${highliteBooksCollection.booksCollectionId.slug}`}>
          <div className="aLaUneTop">
            <Container className="ventre">
              <div className="content">
                <span className="badge-highlite">{etiquette}</span>
                <p className="auteurs"><span>Parmi nos collections</span></p>
                <h2>{highliteBooksCollection.booksCollectionId.name}</h2>

                <div className="description">
                  <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(highliteBooksCollection.booksCollectionId.intention
                    .replace(/<\/?p>/g, ' ')        // supprime les balises <p> et </p>
                    .replace(/<br\s*\/?>/g, ' ')   // remplace <br> ou <br/> par un espace
                    .replace(/(\r\n|\n|\r)/gm, ' ') // remplace les \n restants
                    .slice(0, sliceLength) + '...') }} />
                </div>
                <p className="ensavoirplus"><b>En savoir plus</b></p>
              </div>
            </Container>
          </div>
        </Link>
      </Carousel.Item>

    );
  };


let localNbHighlightBook = 0; // compteur local

// === FONCTION DE DISPATCH PAR TYPEINFO ===

const renderHighlight = (highlite) => {
  switch (highlite.typeInfo) {
    case 'newBook':
      const book = nouveautes?.[localNbHighlightBook];
      localNbHighlightBook++; // on incrémente après avoir utilisé le livre
      if (!book) return null; // sécurité
      return renderBook({ bookId: book, _id: `newBook-${localNbHighlightBook}` }, "Ça vient de sortir");
    case 'oldBook': return renderBook(highlite, 'Focus');
    case 'news': return renderNews(highlite, 'Actualités');
    case 'author': return renderAuthor(highlite, 'Faisons les présentations');
    case 'booksCollection': return renderBooksCollection(highlite, 'À explorer');
    default:
      return null;
  }
};



  return isLoading ? null : error ? (
    <Message variant="danger">{error?.alaune?.message || error.error}</Message>
  ) : (
    <Carousel 
      fade
      interval={8000}
      pause="hover"
      nextIcon={<span className="next" aria-hidden="true"></span>}
      prevIcon={<span className="prev" aria-hidden="true"></span>}
      className="aLaUne"
      
    >
      {alaune?.highlites?.map((highlite) => renderHighlight(highlite))}

    </Carousel>
  );
};

export default ALaUne;
